import { TourStep } from '../models/tour-step.model';

export const SIDEBAR_TOUR_STEPS: TourStep[] = [
  {
    id: 'dashboard',
    targetId: 'tour-dashboard',
    descriptionKey: 'TOUR.Dashboard.Desc',
  },
  {
    id: 'accounts',
    targetId: 'tour-accounts',
    descriptionKey: 'TOUR.Accounts.Desc',
  },
  {
    id: 'reports',
    targetId: 'tour-reports',
    descriptionKey: 'TOUR.Reports.Desc',
  },
  {
    id: 'verification',
    targetId: 'tour-verification',
    descriptionKey: 'TOUR.Verification.Desc',
  },
  {
    id: 'copyTrading',
    targetId: 'tour-copyTrading',
    descriptionKey: 'TOUR.CopyTrading.Desc',
  },
  {
    id: 'tickets',
    targetId: 'tour-tickets',
    descriptionKey: 'TOUR.Tickets.Desc',
  },
  {
    id: 'web-trade',
    targetId: 'tour-web-trade',
    descriptionKey: 'TOUR.WebTrade.Desc',
  },
  {
    id: 'services',
    targetId: 'tour-services',
    descriptionKey: 'TOUR.Services.Desc',
  },
  {
    id: 'academy',
    targetId: 'tour-academy',
    descriptionKey: 'TOUR.Academy.Desc',
  },
  {
    id: 'bonus',
    targetId: 'tour-bonus',
    descriptionKey: 'TOUR.Bonus.Desc',
  },
  {
    id: 'referral',
    targetId: 'tour-referral',
    descriptionKey: 'TOUR.InviteFriends.Desc',
  },
  {
    id: 'bank',
    targetId: 'tour-bank',
    descriptionKey: 'TOUR.BankCard.Desc',
  },
  {
    id: 'ib-panel',
    targetId: 'tour-ib-panel',
    descriptionKey: 'TOUR.IBPanel.Desc',
  },
  {
    id: 'profile',
    targetId: 'tour-profile',
    descriptionKey: 'TOUR.Profile.Desc',
  },
  {
    id: 'language',
    targetId: 'tour-language',
    descriptionKey: 'TOUR.Language.Desc',
  },
  {
    id: 'theme',
    targetId: 'tour-theme',
    descriptionKey: 'TOUR.Theme.Desc',
  },
  {
    id: 'logout',
    targetId: 'tour-logout',
    descriptionKey: 'TOUR.Logout.Desc',
  },
];
